import { SwiperOptions } from './../../../../../../node_modules/swiper/types/swiper-options.d';
import { afterNextRender, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, Inject, inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { GlobalConfigService } from '../../../../core/services/global-config.service';
import { SharedModule } from '../../../../shared/shared.module';
import { CardComponent } from '../../components/card/card.component';
import { isPlatformBrowser } from '@angular/common';
import { StepByStep } from '../../utils/step-by-step';
import { WhyUs } from '../../utils/why-us';
import { AsksExpansionPanelComponent } from '../../../faq/components/asks-expansion-panel/asks-expansion-panel.component';
import { PartnersComponent } from '../partners/partners.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [SharedModule, CardComponent, AsksExpansionPanelComponent, PartnersComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HomeComponent {
  public globalConfig = inject(GlobalConfigService);
  public steps = StepByStep.steps;
  public reasons = WhyUs.reasons;

  openChat() {
    window.open(this.globalConfig.getContactNumber().redirectUrl, '_blank');
  }

  @ViewChild('swiper') swiper!: ElementRef<any>;

	swiperConfig: SwiperOptions = {
		spaceBetween: 30,
		slidesPerView: 4,
		pagination: true,
		direction: 'horizontal',
		breakpoints: {
			'100': {
				slidesPerView: 1,
			},
			'810': {
				slidesPerView: 2,
			},
			'1280': {
				slidesPerView: 3
			},
      		'1440': {
				slidesPerView: 4,
			},
		},
		autoplay: false,
		updateOnWindowResize: true,
    loop: false,
    speed: 500,
    navigation: true
	}

  constructor(@Inject(PLATFORM_ID) private _platformId: Object) {
		afterNextRender(() => {
			this.handleUpdateSwiperConfig();
		})
	}

	handleUpdateSwiperConfig(): void {
    if (isPlatformBrowser(this._platformId)) {
      this.swiperConfig = {
        ...this.swiperConfig,
        direction: 'horizontal',
      };
    };

    Object.assign(this.swiper.nativeElement, this.swiperConfig);
    this.swiper.nativeElement.initialize();
	}
}
